import { Bed, UtensilsCrossed, Droplets, Shirt, Layers, Repeat } from "lucide-react";
import { IMAGES } from "./images";

export const services = [
  {
    slug: "hotelska-posteljina-jastuci",
    icon: Bed,
    title: "Hotelska posteljina i jastuci",
    shortTitle: "Hotelska posteljina",
    tag: "Za smeštajne objekte",
    cardDesc:
      "Profesionalno pranje čaršava, jastučnica, navlaka i prekrivača za hotele, apartmane i pansione — belina, mekoća i higijena po standardu smeštaja.",
    metaTitle: "Pranje hotelske posteljine Beograd | TOP WASH DOO",
    metaDescription:
      "Profesionalno pranje hotelske posteljine, jastučnica i navlaka u Beogradu. TOP WASH DOO — B2B perionica za hotele, apartmane i pansione. Besplatna procena i fiksni raspored.",
    keywords:
      "pranje hotelske posteljine Beograd, pranje čaršava hotel, perionica za hotele, pranje jastučnica profesionalno, TOP WASH posteljina",
    image: IMAGES.services["hotelska-posteljina-jastuci"],
    imageAlt: "Čista bela hotelska posteljina — profesionalno pranje TOP WASH DOO",
    heroLead:
      "Gost pamti prvi dodir sa posteljinom. Mi brinemo da svaki čaršav, jastučnica i navlaka budu besprekorno čisti, beli i spremni za smenu — bez kompromisa u kvalitetu.",
    sections: [
      {
        heading: "Za koga je ova usluga",
        body:
          "Hoteli, apartmani, hosteli, pansioni i objekti kratkoročnog smeštaja u Beogradu i okolini. Radimo sa inventarom različitog obima — od butik hotela sa deset soba do objekata sa stotinama ležajeva.",
      },
      {
        heading: "Šta peremo",
        body:
          "Platneni i satenski čaršavi, jastučnice, navlake za jastuke i jorgane, prekrivači, dekorativne trake i dodatni tekstil za sobe. Beli i obojeni programi peru se odvojeno, uz kontrolu temperature i pH vrednosti.",
      },
      {
        heading: "Zašto TOP WASH",
        body:
          "Razumemo da prazna soba mora biti spremna u tačno dogovorenom terminu. Fiksni raspored preuzimanja i isporuke, jasan mesečni obračun i dosledan kvalitet — bez iznenađenja u sezoni punog kapaciteta.",
      },
    ],
    benefits: [
      "Kontrolisano pranje belog i obojenog programa odvojeno",
      "Peglanje i pakovanje spremno za postavljanje u sobu",
      "Uklanjanje mrlja i neutralizacija mirisa po tipu tkanine",
      "Fleksibilan obim — dnevno, više puta nedeljno ili po rotaciji",
      "Besplatna procena obima i personalizovana ponuda",
    ],
    faq: [
      {
        q: "Da li prate belinu posteljine kroz vreme?",
        a: "Da. Koristimo programe pranja prilagođene pamuku i mikrofibri, sa kontrolom temperature kako bi belina ostala stabilna i tkanina dugo trajala.",
      },
      {
        q: "Koliki je rok isporuke?",
        a: "Standardni rok obrade je 24 do 48 sati, u zavisnosti od obima i dinamike ugovora. Za veće objekte definišemo raspored unapred.",
      },
      {
        q: "Da li radite sa apartmanima i manjim objektima?",
        a: "Da. Prilagođavamo paket i dinamiku preuzimanja obimu — i manji smeštajni objekti imaju isti nivo usluge kao veći hoteli.",
      },
    ],
  },
  {
    slug: "stolnjaci-salvete",
    icon: UtensilsCrossed,
    title: "Stolnjaci i salvete",
    shortTitle: "Stolnjaci & salvete",
    tag: "Za restorane",
    cardDesc:
      "Pranje i peglanje stolnjaka, damast salveti, prostirki i overlejs za restorane, kafiće, svečane sale i catering — spremno za sto pre svake smene.",
    metaTitle: "Pranje stolnjaka i salveta za restorane Beograd | TOP WASH",
    metaDescription:
      "Profesionalno pranje stolnjaka, salveti i restoranskog tekstila u Beogradu. TOP WASH DOO — pouzdan partner za restorane, kafiće i catering. Besplatna procena.",
    keywords:
      "pranje stolnjaka Beograd, pranje salveti restoran, perionica stolnjaka, pranje damast salveti, restoranski tekstil pranje",
    image: IMAGES.services["stolnjaci-salvete"],
    imageAlt: "Elegantno postavljen sto u restoranu — pranje stolnjaka TOP WASH",
    heroLead:
      "Prvi utisak u restoranu počinje od stola. Naš tim brine da stolnjaci budu besprekorno beli, salvete uredno ispeglane, a tekstil spreman pre nego što konobari krenu u smenu.",
    sections: [
      {
        heading: "Za koga je ova usluga",
        body:
          "Restorani, bistroi, kafići, picerije, svečane sale, banketi i catering servisi koji svakodnevno koriste veliki obim stolnjaka, salveti i prostirki.",
      },
      {
        heading: "Šta peremo",
        body:
          "Beli i obojeni stolnjaci, damast i platnene salvete, overlejs, podne prostirke za sto, runners i dekorativni tekstil za bankete. Peglanje po ivicama i sortiranje po veličini i boji.",
      },
      {
        heading: "Operativna pouzdanost",
        body:
          "Znamo da vikendom i u sezoni obim raste. Dogovaramo dinamiku preuzimanja koja prati vaš promet — ujutru pre otvaranja, posle zatvaranja ili više puta dnevno.",
      },
    ],
    benefits: [
      "Peglanje i pakovanje spremno za postavljanje na sto",
      "Odvajanje belog i obojenog tekstila u pranju",
      "Uklanjanje mrlja od vina, ulja i hrane po tipu tkanine",
      "Skladištenje i rotacija po vašem rasporedu",
      "Jasan obračun po komadu ili kilogramu",
    ],
    faq: [
      {
        q: "Da li peglate stolnjake?",
        a: "Da. Stolnjaci i salvete se peglaju i pakuju prema dogovoru, spremni za direktnu upotrebu u sali.",
      },
      {
        q: "Radite li sa cateringom i eventima?",
        a: "Da. Za veće događaje planiramo preuzimanje i isporuku unapred, u skladu sa brojem gostiju i rasporedom servisa.",
      },
      {
        q: "Kako se formira cena?",
        a: "Na osnovu tipa tekstila, obima i dinamike saradnje. Besplatna procena daje fiksnu ponudu bez skrivenih stavki.",
      },
    ],
  },
  {
    slug: "peskir-frotir-spa",
    icon: Droplets,
    title: "Peškiri, frotir i spa tekstil",
    shortTitle: "Peškiri & spa",
    tag: "Za spa i wellness",
    cardDesc:
      "Pranje ručnika, kupatilskih setova, spa ogrtača i podnih prostirki — mekoća, higijena i ujednačen kvalitet za wellness, spa i fitnes centre.",
    metaTitle: "Pranje peškira i spa tekstila Beograd | TOP WASH DOO",
    metaDescription:
      "Profesionalno pranje peškira, frotira i spa tekstila u Beogradu. TOP WASH — partner za wellness centre, spa, salone lepote i teretane. Besplatna procena.",
    keywords:
      "pranje peškira Beograd, pranje frotira spa, perionica wellness, pranje ogrtača spa, pranje ručnika hotel",
    image: IMAGES.services["peskir-frotir-spa"],
    imageAlt: "Spa peškiri i frotir — profesionalno pranje TOP WASH",
    heroLead:
      "U spa i wellness okruženju gost oseća kvalitet na koži. Peremo peškire i frotir tako da zadrže mekoću, svežinu i higijenski standard — dan za danom.",
    sections: [
      {
        heading: "Za koga je ova usluga",
        body:
          "Spa centri, wellness objekti, hoteli sa bazenom, teretane, saloni lepote i medicinski wellness prostori koji koriste veliki obim peškira i ogrtača.",
      },
      {
        heading: "Šta peremo",
        body:
          "Ručnici za ruke i telo, kupatilski setovi, spa ogrtači, peškiri za ležaje, podne prostirke, mantili za tretmane i pomoćni frotir. Program pranja prilagođen visokofrekventnoj upotrebi.",
      },
      {
        heading: "Higijenski fokus",
        body:
          "Pranje na propisanim temperaturama, odvajanje tekstila po zonama i kontrola mirisa i mekoće. Cilj je da svaki komad bude spreman za gosta bez kompromisa.",
      },
    ],
    benefits: [
      "Očuvanje mekoće i gustine frotira kroz više ciklusa pranja",
      "Uklanjanje mirisa i dubinsko osvežavanje tkanine",
      "Rotacija inventara po dogovorenom rasporedu",
      "Pakovanje sortirano po veličini i nameni",
      "Prilagođen obim za dnevne i sezonske pikove",
    ],
    faq: [
      {
        q: "Da li peškiri gube mekoću posle pranja?",
        a: "Koristimo programe i sredstva prilagođena frotiru kako bi tkanina zadržala mekoću i upijanje i posle više ciklusa.",
      },
      {
        q: "Možete li prati velike količine dnevno?",
        a: "Da. Za objekte sa visokim prometom definišemo dnevnu rotaciju i višestruka preuzimanja po potrebi.",
      },
      {
        q: "Radite li sa hotelskim spa odeljenjima?",
        a: "Da. Integrišemo spa tekstil u širi ugovor za hotel ili ga tretiramo kao zaseban paket — po vašem operativnom modelu.",
      },
    ],
  },
  {
    slug: "radne-uniforme",
    icon: Shirt,
    title: "Radne uniforme",
    shortTitle: "Radne uniforme",
    tag: "Kompletno osoblje",
    cardDesc:
      "Pranje kuvarskih jakni, kecelja, konobarskih i sobarskih uniformi — po materijalu, sa uklanjanjem mrlja i očuvanjem boje i forme.",
    metaTitle: "Pranje radnih uniformi za restorane i hotele Beograd | TOP WASH DOO",
    metaDescription:
      "Profesionalno pranje radnih uniformi za restorane, hotele i kafiće u Beogradu. Kuvarske jakne, kecelje, konobarska i sobarska odeća — TOP WASH DOO.",
    keywords:
      "pranje uniformi Beograd, pranje kuvarskih jakni, pranje kecelja restoran, perionica uniformi ugostiteljstvo, pranje radne odeće",
    image: IMAGES.services["radne-uniforme"],
    imageAlt: "Kuvar u profesionalnoj uniformi — pranje radne odeće TOP WASH",
    heroLead:
      "Uniforma je lice vašeg tima pred gostom. Peremo radnu odeću po materijalu i nameni — uklanjamo mrlje, održavamo boju i vraćamo komade spremne za sledeću smenu.",
    sections: [
      {
        heading: "Za koga je ova usluga",
        body:
          "Restorani, hoteli, kafići, pekare, catering i objekti sa većim brojem zaposlenih u kuhinji, sali, recepciji i housekeeping timu.",
      },
      {
        heading: "Šta peremo",
        body:
          "Kuvarske jakne i pantalone, kecelje, kape, konobarske košulje i prsluci, uniforme sobarica, recepcije i tehničkog osoblja. Poseban tretman za mrlje od ulja, začina i hrane.",
      },
      {
        heading: "Profesionalan izgled tima",
        body:
          "Uredna uniforma podiže poverenje gosta. Naš proces kombinuje pranje, peglanje i sortiranje po veličini i ulozi — da svaki zaposleni uvek ima spreman komplet.",
      },
    ],
    benefits: [
      "Tretman mrlja od ulja, začina i napitaka",
      "Pranje po tipu materijala (pamuk, poliester, mešavine)",
      "Peglanje i pakovanje po veličini ili po zaposlenom",
      "Rotacija više kompleta po osobi",
      "Diskretna i pouzdana logistika preuzimanja",
    ],
    faq: [
      {
        q: "Da li uklanjate mrlje sa kuvarskih jakni?",
        a: "Da. Koristimo pre-tretman i programe pranja prilagođene masnim i proteinskim mrljama karakterističnim za kuhinju.",
      },
      {
        q: "Možete li prati i ličnu radnu odeću zaposlenih?",
        a: "U B2B saradnji radimo sa uniformama koje obezbeđuje poslodavac. Obim i model definišemo u proceni.",
      },
      {
        q: "Koliko kompleta po zaposlenom preporučujete?",
        a: "Zavisi od smena i dinamike — u proceni predlažemo rotaciju koja sprečava nedostatak čiste odeće u špicu.",
      },
    ],
  },
  {
    slug: "jorgani-prekivaci-cebad",
    icon: Layers,
    title: "Jorgani, prekrivači i ćebad",
    shortTitle: "Jorgani & ćebad",
    tag: "Sezonska rotacija",
    cardDesc:
      "Dubinsko pranje jorgana, jastuka, prekrivača i dekorativnih ćebadi — voluminozan inventar, sušenje bez gužvanja i pakovanje u zaštitne navlake.",
    metaTitle: "Pranje jorgana i ćebadi Beograd | TOP WASH DOO",
    metaDescription:
      "Profesionalno pranje jorgana, prekrivača i ćebadi za hotele i pansione u Beogradu. TOP WASH DOO — sezonska i redovna rotacija voluminoznog tekstila.",
    keywords:
      "pranje jorgana Beograd, pranje ćebadi hotel, pranje prekrivača, dubinsko pranje jastuka, sezonsko pranje posteljine",
    image: IMAGES.services["jorgani-prekivaci-cebad"],
    imageAlt: "Jorgan i prekrivač na krevetu — pranje voluminoznog tekstila TOP WASH",
    heroLead:
      "Jorgani i ćebad zahtevaju poseban pristup — obim, sušenje i pakovanje moraju biti besprekorni. Preuzimamo voluminozan inventar i vraćamo ga svež, suv i spreman za upotrebu.",
    sections: [
      {
        heading: "Za koga je ova usluga",
        body:
          "Hoteli, apartmani, pansioni, domovi zdravlja i objekti koji sezonski ili redovno prate jorgane, jastuke, prekrivače i dekorativne ćebade.",
      },
      {
        heading: "Šta peremo",
        body:
          "Letnji i zimski jorgani, jastuci različitih punjenja (navlake), prekrivači, dekorativne ćebade, zaštitne navlake i dodatni slojevi posteljine.",
      },
      {
        heading: "Sezonska i redovna rotacija",
        body:
          "Planiramo preuzimanje pre sezone, posle pikova ili u fiksnim intervalima — bez zagušenja skladišta i bez odloženog pranja koje utiče na kvalitet smeštaja.",
      },
    ],
    benefits: [
      "Pranje voluminoznog tekstila u industrijskim kapacitetima",
      "Sušenje bez gužvanja i očuvanje punjenja jastuka",
      "Pakovanje u zaštitne navlake za skladištenje",
      "Sezonski plan preuzimanja i isporuke",
      "Kontrola alergena i mirisa u dubinskom pranju",
    ],
    faq: [
      {
        q: "Da li perete i jastuke sa punjenjem?",
        a: "Peremo navlake i, po dogovoru, jastuke u skladu sa tipom punjenja i preporukama proizvođača.",
      },
      {
        q: "Koliko traje sezonsko pranje većeg inventara?",
        a: "Rok zavisi od obima — u proceni definišemo tačan plan sa datumima preuzimanja i vraćanja.",
      },
      {
        q: "Da li nudite skladištenje između sezona?",
        a: "Fokusirani smo na pranje i isporuku. Pakovanje je prilagođeno bezbednom skladištenju u vašem objektu.",
      },
    ],
  },
  {
    slug: "rotacija-dostava",
    icon: Repeat,
    title: "Rotacija i dostava tekstila",
    shortTitle: "Rotacija & dostava",
    tag: "Ugovoreni raspored",
    cardDesc:
      "Organizovana preuzimanja i isporuke po fiksnom rasporedu — dnevno ili više puta nedeljno. Vi vodite posao, mi obezbeđujemo da čist tekstil uvek bude na raspolaganju.",
    metaTitle: "Rotacija i dostava tekstila za ugostiteljstvo Beograd | TOP WASH",
    metaDescription:
      "Organizovana rotacija i dostava tekstila za restorane i hotele u Beogradu. TOP WASH DOO — fiksni raspored preuzimanja, pouzdana isporuka, B2B logistika.",
    keywords:
      "dostava tekstila Beograd, rotacija veša restoran, preuzimanje veša hotel, logistika perionica ugostiteljstvo, TOP WASH dostava",
    image: IMAGES.services["rotacija-dostava"],
    imageAlt: "Dostava tekstila — rotacija i logistika TOP WASH DOO",
    heroLead:
      "Kvalitet pranja nije dovoljan ako tekstil ne stigne na vreme. Gradimo logistiku oko vašeg objekta — fiksni termini, predvidiv obim i pouzdana isporuka čistog inventara.",
    sections: [
      {
        heading: "Za koga je ova usluga",
        body:
          "Restorani, hoteli, kafići, spa centri i catering servisi koji ne mogu da dozvole prekid u snabdevanju čistim tekstilom — posebno u vikendima i sezoni.",
      },
      {
        heading: "Kako funkcioniše rotacija",
        body:
          "Definišemo obim, učestalost i termine preuzimanja prljavog i isporuke čistog tekstila. Model može biti dnevni, višednevni ili kombinovan sa sezonskim pikom — u skladu sa vašim operativnim ritmom.",
      },
      {
        heading: "Pouzdanost kao standard",
        body:
          "Na isti termin dolazimo iz smene u smenu. Na taj način vaš tim ne gubi vreme na koordinaciju, a gosti ne osećaju nedostatak u kvalitetu usluge.",
      },
    ],
    benefits: [
      "Fiksni termini preuzimanja i isporuke u Beogradu",
      "Prilagođen raspored za vikende i praznike",
      "Sortiranje prljavog tekstila po kategorijama pri preuzimanju",
      "Isporuka spremnog inventara za direktnu upotrebu",
      "Jedna kontakt tačka za celu saradnju",
    ],
    faq: [
      {
        q: "Da li pokrivate ceo Beograd?",
        a: "Primarno radimo u Beogradu i okolini. Tačnu zonu i termine potvrđujemo u besplatnoj proceni.",
      },
      {
        q: "Možete li dolaziti više puta dnevno?",
        a: "Da, za objekte sa visokim prometom dogovaramo višestruka preuzimanja i isporuke.",
      },
      {
        q: "Šta ako nam zatreba vanredno preuzimanje?",
        a: "Po dogovoru omogućavamo dodatne termine — posebno u sezoni i za evente.",
      },
    ],
  },
];

import { enrichService } from "./serviceDetails";

export function getServiceBySlug(slug) {
  const service = services.find((s) => s.slug === slug);
  return service ? enrichService(service) : undefined;
}

export function getServicePath(slug) {
  return `/usluge/${slug}`;
}
